import { jsx as t, jsxs as b, Fragment as H } from "react/jsx-runtime";
import Z, { useState as M, useRef as P, useEffect as _ } from "react";
import { z as a } from "zod";
import { withZod as A } from "@made-people/react-prop-guard";
import { withManagedProps as G } from "@made-people/managed-props";
import { Drawer as I } from "@made-people/blueprint-drawer";
import { filterGlasgowBlueprint as v } from "./index-blueprint.es.js";
import { useFormatRangeValue as W, useFacets as p, useSort as $, useSearchResultMeta as U } from "@made-people/grease-search";
import { useTranslate as V } from "@made-people/grease-translations";
import { Accordion as K } from "@made-people/blueprint-accordion";
import { Checkbox as x } from "@made-people/blueprint-form";
import D from "clsx";
import { Range as q } from "@made-people/blueprint-range";
import { buttonAsButtonSchema as B, ButtonAsButton as w } from "@made-people/blueprint-button";
import { overlayEventEmitter as J } from "@made-people/blueprint-overlay";
import { CrossIcon as Q } from "@made-people/blueprint-icons";
import { headingSchema as X, Heading as Y } from "@made-people/blueprint-heading";
import "@made-people/blueprint";
const ee = ({
  facet: e,
  toggleFacet: i
}) => {
  const n = v.main.styles(), c = V();
  return e.type !== "group" ? null : /* @__PURE__ */ t("div", { className: n.filterGroupedContainer, children: e.children.map((o) => /* @__PURE__ */ b("div", { className: n.filterGroupedSection, children: [
    /* @__PURE__ */ t("div", { className: n.filterSubheading, children: c(`Filter_${o.name}`) }),
    /* @__PURE__ */ t("div", { className: n.filterGroupedGrid, children: o.values.map((r) => /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: n.filterGroupedButton,
        "data-selected": r.selected,
        onClick: () => {
          i(o.id, r.id);
        },
        children: r.name
      },
      r.id
    )) })
  ] }, o.id)) });
}, O = (e) => {
  const {
    value: i,
    filterId: n,
    toggleFacet: c,
    expandedIds: o,
    handleToggleExpand: r,
    checkBoxClassName: l
  } = e, u = !!(i.children && i.children.length > 0), h = o.has(i.id), m = v.main.styles();
  return /* @__PURE__ */ b(H, { children: [
    /* @__PURE__ */ b(
      "div",
      {
        className: m.filterOptionHierarchicalItem,
        style: { marginLeft: `${i.level * 12}px` },
        children: [
          /* @__PURE__ */ t(
            x,
            {
              checked: i.selected,
              label: i.name,
              className: D(l, "w-full"),
              onChange: () => {
                c(n, i.id);
              }
            }
          ),
          u && /* @__PURE__ */ t(
            "button",
            {
              type: "button",
              className: m.filterOptionHierarchicalItemButton,
              "aria-label": `Toggle ${i.name}`,
              "aria-expanded": h,
              onClick: () => r(i.id),
              onKeyDown: (s) => {
                (s.key === "Enter" || s.key === " ") && (s.preventDefault(), r(i.id));
              },
              tabIndex: 0,
              children: h ? "−" : "+"
            }
          )
        ]
      }
    ),
    u && h && /* @__PURE__ */ t("div", { className: m.filterOptionHierarchicalList, children: i.children.map((s) => /* @__PURE__ */ t(
      O,
      {
        value: s,
        filterId: n,
        toggleFacet: c,
        expandedIds: o,
        handleToggleExpand: r
      },
      s.id
    )) })
  ] });
}, te = ({
  facet: e,
  setFacetRange: i
}) => {
  const [n, c] = M([
    e.selectedMin ?? e.min,
    e.selectedMax ?? e.max
  ]), o = P(n), r = W();
  return _(() => {
    const l = [
      e.selectedMin ?? e.min,
      e.selectedMax ?? e.max
    ];
    c(l), o.current = l;
  }, [e.selectedMin, e.selectedMax, e.min, e.max]), /* @__PURE__ */ t(
    q,
    {
      min: e.min,
      max: e.max,
      value: n,
      onValueChange: (l) => {
        c(l), o.current = l;
      },
      onValueCommitted: () => {
        const [l, u] = o.current;
        l === (e.selectedMin ?? e.min) && u === (e.selectedMax ?? e.max) || i(e.id, l, u);
      },
      formatValue: r
    }
  );
}, ie = ({
  facet: e,
  toggleFacet: i,
  setFacetRange: n,
  expandedIds: c,
  handleToggleExpand: o
}) => {
  const r = v.main.styles();
  return e.type === "group" ? null : e.type === "range" ? /* @__PURE__ */ t("div", { className: r.filterOptions, children: /* @__PURE__ */ t(te, { facet: e, setFacetRange: n }) }) : /* @__PURE__ */ t("div", { className: r.filterOptions, children: e.type === "checkbox-hierarchical" ? e.values.map((l) => /* @__PURE__ */ t(
    O,
    {
      value: l,
      filterId: e.id,
      checkBoxClassName: r.filterOption,
      toggleFacet: i,
      expandedIds: c,
      handleToggleExpand: o
    },
    l.id
  )) : e.type === "checkbox" ? e.values.map((l) => /* @__PURE__ */ t(
    x,
    {
      checked: l.selected,
      label: l.name,
      className: r.filterOption,
      onChange: () => {
        i(e.id, l.id);
      }
    },
    l.id
  )) : null });
}, ne = ({
  facet: e,
  toggleFacet: i,
  setFacetRange: n,
  expandedIds: c,
  handleToggleExpand: o
}) => e.type === "group" ? /* @__PURE__ */ t(
  ee,
  {
    facet: e,
    toggleFacet: i,
    expandedIds: c,
    handleToggleExpand: o
  }
) : /* @__PURE__ */ t(
  ie,
  {
    facet: e,
    toggleFacet: i,
    setFacetRange: n,
    expandedIds: c,
    handleToggleExpand: o
  }
), z = a.object({
  template: a.literal("glasgow").optional(),
  variants: a.custom().optional(),
  checkboxIndicator: a.custom().optional(),
  accordion: a.any().optional(),
  sortEnabled: a.boolean().optional(),
  actions: a.object({
    apply: B.optional(),
    clear: B.or(a.literal(!1)).optional()
  }).optional(),
  applyButtonVariants: a.custom().optional(),
  clearButtonVariants: a.custom().optional(),
  className: a.string().optional(),
  activeFilters: a.object({
    enabled: a.boolean().optional(),
    icon: a.custom().optional(),
    buttonVariants: a.custom().optional(),
    heading: X.or(a.literal(!1)).optional(),
    clearFilterEnabled: a.boolean().optional()
  }).optional()
}), le = G(
  "FilterGlasgow",
  A(
    {
      schema: z,
      defaultProps: {
        sortEnabled: !1,
        actions: {
          clear: {
            variants: {
              width: "full",
              color: "black",
              style: "outline",
              size: "lg"
            }
          },
          apply: {
            variants: {
              width: "full",
              color: "black",
              style: "solid",
              size: "lg"
            }
          }
        },
        activeFilters: {
          enabled: !0,
          icon: /* @__PURE__ */ t(Q, {}),
          heading: {
            heading: "Filter_ActiveFilters",
            variants: { headingSize: "sm" }
          }
        }
      }
    },
    (e) => {
      var F, k, y, N, S, C, R, E;
      const {
        facets: i,
        toggleFacet: n,
        setFacetRange: c,
        resetFacets: o,
        activeFacetValues: r
      } = p(), { sortAlternatives: l, toggleSort: u } = $(), h = U(), m = V(), s = v.main.styles(), [T, j] = Z.useState(
        () => /* @__PURE__ */ new Set()
      ), L = (d) => {
        j((f) => {
          const g = new Set(f);
          return g.has(d) ? g.delete(d) : g.add(d), g;
        });
      };
      return /* @__PURE__ */ b("div", { className: D(s.base, e.className), children: [
        /* @__PURE__ */ t("div", { className: s.filterHeader, children: /* @__PURE__ */ t("h4", { className: s.filterHeaderTitle, children: m("Filter_Header_Title") }) }),
        ((F = e.activeFilters) == null ? void 0 : F.enabled) && r.length > 0 && /* @__PURE__ */ b("div", { className: s.activeFilters, children: [
          ((k = e.activeFilters) == null ? void 0 : k.heading) && /* @__PURE__ */ t(Y, { ...e.activeFilters.heading }),
          /* @__PURE__ */ b("div", { className: s.activeFiltersList, children: [
            e.activeFilters.clearFilterEnabled && /* @__PURE__ */ t(
              w,
              {
                onClick: o,
                variants: {
                  width: "auto",
                  style: "solid",
                  size: "sm",
                  ...(y = e.activeFilters) == null ? void 0 : y.buttonVariants
                },
                iconRight: (N = e.activeFilters) == null ? void 0 : N.icon,
                label: m("Filter_Clear_All"),
                ...(S = e.actions) == null ? void 0 : S.clear
              }
            ),
            r.map((d) => {
              var f, g;
              return /* @__PURE__ */ t(
                w,
                {
                  iconRight: (f = e.activeFilters) == null ? void 0 : f.icon,
                  variants: {
                    width: "auto",
                    style: "solid",
                    size: "sm",
                    ...(g = e.activeFilters) == null ? void 0 : g.buttonVariants
                  },
                  onClick: () => {
                    n(
                      d.facetId,
                      d.id
                    );
                  },
                  label: d.name
                },
                d.id
              );
            })
          ] })
        ] }),
        /* @__PURE__ */ t(
          K,
          {
            ...e.accordion,
            radixAccordionSettings: {
              content: {
                forceMount: !0
              }
            },
            blueprint: v.accordion,
            items: [
              ...e.sortEnabled && l.length > 0 ? [
                {
                  content: {
                    value: "sort",
                    trigger: m("Filter_Sort_Title"),
                    content: /* @__PURE__ */ t("div", { className: s.filterOptions, children: l.map((d) => /* @__PURE__ */ t(
                      x,
                      {
                        checked: d.selected,
                        label: d.name,
                        className: s.filterOption,
                        onChange: () => {
                          u(d.id);
                        }
                      },
                      d.id
                    )) })
                  }
                }
              ] : [],
              ...i.map((d) => ({
                content: {
                  value: d.id,
                  trigger: m(d.name),
                  content: /* @__PURE__ */ t(
                    ne,
                    {
                      facet: d,
                      toggleFacet: n,
                      setFacetRange: c,
                      expandedIds: T,
                      handleToggleExpand: L
                    }
                  )
                }
              }))
            ]
          }
        ),
        /* @__PURE__ */ b("div", { className: s.bottomRow, children: [
          ((C = e.actions) == null ? void 0 : C.clear) && /* @__PURE__ */ t(
            w,
            {
              onClick: () => {
                o();
              },
              label: m("Filter_Clear_All"),
              ...(R = e.actions) == null ? void 0 : R.clear
            }
          ),
          h && /* @__PURE__ */ t(
            w,
            {
              onClick: () => J.emit("close", { overlayId: "filter" }),
              label: m("Filter_Apply", {
                totalProducts: h.totalItems
              }),
              ...(E = e.actions) == null ? void 0 : E.apply
            }
          )
        ] })
      ] });
    }
  )
), ae = {
  variants: {
    rounded: { initial: "medium", lg: "none" }
  }
}, oe = () => {
  const [e, i] = M(
    typeof window < "u" ? window.innerWidth > 1024 : !1
  );
  return _(() => {
    const n = () => {
      i(window.innerWidth > 1024);
    };
    return window.addEventListener("resize", n), () => window.removeEventListener("resize", n);
  }, []), e;
}, re = a.object({
  as: a.literal("drawer").optional(),
  drawerSettings: a.custom().optional().describe("Settings for the drawer"),
  direction: a.object({
    mobile: a.enum(["left", "top", "bottom", "right"]).optional(),
    desktop: a.enum(["left", "top", "bottom", "right"]).optional()
  }).optional()
}), se = a.discriminatedUnion("template", [
  z.merge(re)
]), Ee = G(
  "Filter",
  A(
    {
      schema: se,
      defaultProps: {
        drawerSettings: ae,
        direction: {
          mobile: "bottom",
          desktop: "left"
        }
      }
    },
    (e) => {
      var c, o, r, l, u, h, m, s;
      const i = oe();
      let n;
      return e.template === "glasgow" ? n = /* @__PURE__ */ t(le, { ...e }) : n = null, e.as === "drawer" ? /* @__PURE__ */ t(
        I,
        {
          customOverlayId: "filter",
          variants: {
            rounded: {
              initial: "medium",
              lg: "none"
            },
            direction: i ? ((c = e == null ? void 0 : e.direction) == null ? void 0 : c.desktop) ?? ((o = e == null ? void 0 : e.direction) == null ? void 0 : o.mobile) : ((r = e == null ? void 0 : e.direction) == null ? void 0 : r.mobile) ?? ((l = e == null ? void 0 : e.direction) == null ? void 0 : l.desktop)
          },
          ...e.drawerSettings,
          direction: i ? ((u = e == null ? void 0 : e.direction) == null ? void 0 : u.desktop) ?? ((h = e == null ? void 0 : e.direction) == null ? void 0 : h.mobile) : ((m = e == null ? void 0 : e.direction) == null ? void 0 : m.mobile) ?? ((s = e == null ? void 0 : e.direction) == null ? void 0 : s.desktop),
          children: /* @__PURE__ */ t(I.Content, { children: n })
        }
      ) : /* @__PURE__ */ t(H, { children: n });
    }
  )
), Ie = (e) => /* @__PURE__ */ t("svg", { viewBox: "0 0 24 24", ...e, children: /* @__PURE__ */ t("path", { d: "M7 10l5 5 5-5", fill: "none", stroke: "currentColor", strokeWidth: "2" }) }), Be = (e) => /* @__PURE__ */ t(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    className: "w-5 h-5",
    ...e,
    children: /* @__PURE__ */ t(
      "path",
      {
        fill: "#000",
        fillRule: "evenodd",
        d: "M2.6422 5.0249a2.93 2.93 0 0 1 4.9042 1.3218H19.25a.75.75 0 0 1 0 1.5H7.5464a2.9298 2.9298 0 0 1-4.9042 1.3218 2.9298 2.9298 0 0 1-.7606-1.3218H.75a.75.75 0 0 1 0-1.5h1.1316a2.9298 2.9298 0 0 1 .7606-1.3218Zm2.0718.6418a1.43 1.43 0 1 0 0 2.86 1.43 1.43 0 0 0 0-2.86Zm4.5352 5.9652a2.93 2.93 0 0 1 4.144.0001c.3687.3688.6295.8257.7611 1.3217H19.25a.75.75 0 0 1 0 1.5h-5.0957a2.931 2.931 0 0 1-2.8333 2.181c-.778 0-1.523-.3103-2.0718-.8592a2.9296 2.9296 0 0 1-.7606-1.3218H.75a.75.75 0 0 1 0-1.5h7.7386a2.9296 2.9296 0 0 1 .7606-1.3218Zm2.0718.6418a1.43 1.43 0 0 0-1.0112 2.4412 1.431 1.431 0 0 0 1.0112.4198c.3794 0 .7432-.1507 1.0115-.419a1.4319 1.4319 0 0 0 .4195-1.012c0-.3788-.1508-.7423-.4195-1.011a1.4304 1.4304 0 0 0-1.0115-.419Z",
        clipRule: "evenodd"
      }
    )
  }
);
export {
  Ie as ArrowDown,
  ne as FacetContentRenderer,
  Ee as Filter,
  le as FilterGlasgow,
  Be as FilterIcon,
  ee as GroupedFacetRenderer,
  O as HierarchicalFacetValue,
  te as RangeFacetValue,
  ie as RegularFacetRenderer,
  z as filterGlasgowSchema,
  se as filterSchema
};
//# sourceMappingURL=index.es.js.map
